//Get ParameterizedPage parameters or url parameters
export function getSearch(
  queryString?: string,
  parseType?: 'url' | 'parameterizedPage',
): string[] | undefined {
  queryString = queryString || ``;
  switch (parseType) {
    case `url`:
      queryString = queryString.startsWith(`?`)
        ? queryString.slice(1)
        : queryString;
      const keyValuePairs = queryString.split(`&`);

      const arr: string[] = [];

      keyValuePairs.forEach((pair) => {
        const [key, value] = pair.split(`=`);
        if (key && value) arr.push(`${key}:${value}`);
      });
      return arr;

    case `parameterizedPage`:
      const searchParams: string[] = [];
      queryString.split(`,`).forEach((param) => {
        const [key, value] = param.split(`=`);
        if (key && value) searchParams.push(`${key}:${value}`);
      });
      return searchParams;

    default:
      return;
  }
}
